module.exports = "\r\n\r\nh3{\r\n    font-weight: normal;\r\n     font-size: 16px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shoppingcart/auto-log-out-dialog/auto-log-out-dialog.component.css
// module id = ./src/app/shoppingcart/auto-log-out-dialog/auto-log-out-dialog.component.css
// module chunks = main